import { Bell, Trash2 } from "lucide-react";
import {
  getReminderUrgency,
  getUrgencyLabel,
  getMadeOrBoughtLabel,
  getDurationLabel,
} from "../../utils/reminderUtils";

const URGENCY_STYLES = {
  OVERDUE: { iconBg: "bg-red-50", icon: "text-red-700", pill: "bg-red-50 text-red-700" },
  DUE_SOON: { iconBg: "bg-amber-50", icon: "text-amber-700", pill: "bg-amber-50 text-amber-700" },
  FRESH: { iconBg: "bg-gray-100", icon: "text-gray-600", pill: "bg-gray-100 text-gray-600" },
};

export function ReminderRow({ reminder, onEdit, onDelete, isLast }) {
  const urgency = getReminderUrgency(reminder);
  const styles = URGENCY_STYLES[urgency];

  return (
    <div
      className={`flex items-center justify-between gap-3 p-4 hover:bg-gray-50 transition-colors group ${
        isLast ? "rounded-b-lg" : ""
      }`}
    >
      <button
        onClick={() => onEdit(reminder)}
        className="flex items-center gap-3 min-w-0 flex-1 text-left"
      >
        <div className={`w-9 h-9 rounded-lg ${styles.iconBg} flex items-center justify-center flex-shrink-0`}>
          <Bell className={`w-[18px] h-[18px] ${styles.icon}`} />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-gray-900 truncate">
            {reminder.itemName}
          </p>
          <p className="text-xs text-gray-500 truncate">
            Bought {getMadeOrBoughtLabel(reminder)} · lasts{" "}
            {getDurationLabel(reminder.durationDays)}
          </p>
        </div>
      </button>

      <div className="flex items-center gap-3.5 flex-shrink-0">
        <span className={`text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ${styles.pill}`}>
          {getUrgencyLabel(reminder)}
        </span>
        <button
          onClick={() => onDelete(reminder.reminderId)}
          className="opacity-100 sm:opacity-50 sm:group-hover:opacity-100 p-2 hover:bg-gray-100 rounded transition-opacity"
          aria-label={`Delete reminder for ${reminder.itemName}`}
        >
          <Trash2 className="w-4 h-4 text-gray-400 hover:text-red-500 transition-colors" />
        </button>
      </div>
    </div>
  );
}
